import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cps-error-modal',
  templateUrl: './cps-error-modal.component.html',
  styleUrls: ['./cps-error-modal.component.scss']
})
export class CpsErrorModalComponent implements OnInit {

  constructor(public translationService: TranslateService) {

  }

  ngOnInit(): void {
  }

}
